import { render, staticRenderFns } from "./UnAuthorize.vue?vue&type=template&id=61400f96&scoped=true"
import script from "./UnAuthorize.vue?vue&type=script&lang=js"
export * from "./UnAuthorize.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61400f96",
  null
  
)

export default component.exports